import { BaseEntity } from '../../../models';
import { UnidadeNegocio } from '../unidade-negocio';
import { Mercado } from '../../mercado';

export class UnidadeNegocioMercado implements BaseEntity {
    readonly id: number;
    idUnidadeNegocio: number;
    unidadeNegocio: UnidadeNegocio;
    idMercado: number;
    mercado: Mercado;
}
